import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import HelioscopeDesignsList from 'helioscopeImport/components/helioscopeDesignsList/components/HelioscopeDesignsListComponent';
import SVG from 'react-inlinesvg';
import { clearHelioscopeDesignsList, fetchHelioscopeDesignsList } from 'actions';
import { connect, ConnectedProps } from 'react-redux';
import { FormattedMessage } from 'react-intl';

interface HelioscopeDesignsProps {
  match: {
    params: {
      projectId: string;
      productId: string;
    };
  };
}

type Props = ConnectedProps<typeof connector> & HelioscopeDesignsProps;

export const HelioscopeDesigns: React.FC<Props> = ({ dispatch, helioscopeDesignsList, match, isPrivilegedUser }) => {
  const navigate = useNavigate();
  const { projectId, productId } = match.params;

  useEffect(() => {
    dispatch(fetchHelioscopeDesignsList(projectId));

    return () => {
      dispatch(clearHelioscopeDesignsList());
    };
  }, [dispatch, projectId]);

  const goBack = useCallback(() => {
    navigate('/hs/list');
  }, [navigate]);

  const pageHeader = useCallback(() => {
    const { name } = helioscopeDesignsList;

    return (
      <div className="page-header">
        <div className="page-title" onClick={goBack}>
          <SVG className="svg-back-icon" src={require('assets/media/icons/backward_arrow_icon.svg')} />
          <FormattedMessage id="my.helioscope.projects" />
        </div>
        <div className="page-subtitle">/ {name || '...'}</div>
      </div>
    );
  }, [helioscopeDesignsList, goBack]);

  // Main render logic
  const { isReady, designs } = helioscopeDesignsList;

  if (isReady && designs.length === 0) {
    return (
      <div className="app-content">
        <Header productId={productId} projectId={projectId} />
        <div className="helioscope_import helioscope-import-designs">
          {pageHeader()}
          <div className="main-title">Could not find any projects</div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app-content">
      <Header productId={productId} projectId={projectId} />
      <div className="helioscope_import helioscope-import-designs">
        {pageHeader()}
        <div className="body">
          <HelioscopeDesignsList  
            dispatch={dispatch} 
            projectID={projectId} 
            helioscopeDesignsList={helioscopeDesignsList} 
            user={user} 
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  helioscopeDesignsList: state.helioscopeDesignsList,
  isPrivilegedUser: state.user.isPrivilegedUser,
  user: state.user
});

const connector = connect(mapStateToProps);

export default connector(HelioscopeDesigns);
